import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PurchasedItem from './purchased-item-model'
import {
  CreatePurchasedItemAsync,
  DeletePurchasedItemAsync,
  LoadPurchasedItemsAsync,
} from './purchasedItem-thunk'
const initialState: purchasedItemSliceState = {
  purchasedItem: [],
  selected_purchasedItem: '',
  is_loading_purchasedItem: false,
  is_creating_purchasedItem: false,
  is_deleting_purchasedItem: false,
}
export interface purchasedItemSliceState {
  purchasedItem: PurchasedItem[]
  selected_purchasedItem?: string
  is_loading_purchasedItem: boolean
  is_creating_purchasedItem: boolean
  is_deleting_purchasedItem: boolean
}
export const purchasedItemSlice = createSlice({
  name: 'purchasedItem',
  initialState,
  reducers: {
    setSelectedpurchasedItem: (state, action) => {
      state.selected_purchasedItem = action.payload
    },
    clearStatepurchasedItem: (state) => {
      state.purchasedItem = []
      state.is_loading_purchasedItem = false
      state.is_creating_purchasedItem = false
      state.is_deleting_purchasedItem = false
    },
    mergepurchasedItem: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_purchasedItem = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.purchasedItem = merge(state.purchasedItem, payload) as any
        }
      }
    },

    add_purchasedItem: (state, action) => {
      if (action.payload) {
        state.purchasedItem = [...state.purchasedItem, action.payload]
      }
    },
    set_purchasedItem: (state, action) => {
      let { key, value, id } = action.payload
      state.purchasedItem = state.purchasedItem.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPurchasedItemsAsync.pending, (state) => {
      state.is_loading_purchasedItem = true
    })
    builder.addCase(LoadPurchasedItemsAsync.fulfilled, (state, action) => {
      state.is_loading_purchasedItem = false
      if (action.payload) {
        state.purchasedItem = action.payload
      }
    })
    builder.addCase(LoadPurchasedItemsAsync.rejected, (state) => {
      state.is_loading_purchasedItem = false
    })
    builder.addCase(CreatePurchasedItemAsync.pending, (state) => {
      state.is_creating_purchasedItem = true
    })
    builder.addCase(CreatePurchasedItemAsync.fulfilled, (state) => {
      state.is_creating_purchasedItem = false
    })
    builder.addCase(CreatePurchasedItemAsync.rejected, (state) => {
      state.is_creating_purchasedItem = false
    })
    builder.addCase(DeletePurchasedItemAsync.pending, (state) => {
      state.is_deleting_purchasedItem = true
    })
    builder.addCase(DeletePurchasedItemAsync.fulfilled, (state, action) => {
      state.is_deleting_purchasedItem = false
      if (state.purchasedItem) {
        state.purchasedItem = state.purchasedItem.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePurchasedItemAsync.rejected, (state) => {
      state.is_deleting_purchasedItem = false
    })
  },
})

export const {
  clearStatepurchasedItem,
  setSelectedpurchasedItem,
  set_purchasedItem,
  mergepurchasedItem,
  add_purchasedItem,
} = purchasedItemSlice.actions

export const get_purchasedItem =
  (id?: string) =>
  (state: {
    purchasedItem: {
      purchasedItem: PurchasedItem[]
    }
  }): PurchasedItem | null => {
    let temp = state?.purchasedItem?.purchasedItem?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.purchasedItem?.purchasedItem[0] || null
  }
export const get_selected_purchasedItem = (state: {
  purchasedItem: purchasedItemSliceState
}): PurchasedItem | null => {
  let id = state?.purchasedItem?.selected_purchasedItem
  let temp = state?.purchasedItem?.purchasedItem?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_purchasedItem = (state: {
  purchasedItem: {
    purchasedItem: PurchasedItem[]
  }
}): PurchasedItem[] => {
  let temp = state?.purchasedItem?.purchasedItem
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_purchasedItem_busy = (state: {
  purchasedItem: purchasedItemSliceState
}) => {
  return (
    state?.purchasedItem.is_deleting_purchasedItem ||
    state?.purchasedItem.is_loading_purchasedItem ||
    state?.purchasedItem.is_creating_purchasedItem
  )
}
export const is_deleting_purchasedItem_busy = (state: {
  purchasedItem: purchasedItemSliceState
}) => {
  return state?.purchasedItem.is_deleting_purchasedItem
}
export const is_loading_purchasedItem_busy = (state: {
  purchasedItem: purchasedItemSliceState
}) => {
  return state?.purchasedItem.is_loading_purchasedItem
}
export const is_creating_purchasedItem_busy = (state: {
  purchasedItem: purchasedItemSliceState
}) => {
  return state?.purchasedItem.is_creating_purchasedItem
}

export default purchasedItemSlice.reducer
